"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _themeProvider = require("@mmc/theme-provider");
var PROP_TYPES = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  label: _propTypes["default"].node,
  priority: _propTypes["default"].oneOf(_themeProvider.themePriorities),
  theme: _propTypes["default"].string,
  openNewTab: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  clickEvent: _propTypes["default"].func
});
var _default = PROP_TYPES;
exports["default"] = _default;